import { Component, OnInit } from '@angular/core';
import { AppServiceService } from 'src/app/api/app-service.service';

@Component({
  selector: 'app-additives-and-substances',
  templateUrl: './additives-and-substances.page.html',
  styleUrls: ['./additives-and-substances.page.scss'],
})
export class AdditivesAndSubstancesPage implements OnInit {

  constructor(public appService: AppServiceService) { }

  ngOnInit() {
    if (this.appService.isWebVersion) this.appService.getAdditivesAndSub();
  }

  ionViewDidEnter() {
    if (!this.appService.isWebVersion) this.appService.getAdditivesAndSub();
  }

}